// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import App from './App'
import App from '@/Merck'
import router from '@/router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@/css/main.css'
import 'mdi/css/materialdesignicons.min.css'
import middleware from '@/middleware'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-179555242-3',
  router,
  autoTracking: {
    pageviewOnLoad: true,
    page: true
  }
})

Vue.use(Vuetify, {
  theme: {
    primary: '#ee44aa',
    secondary: '#CC9AC6',
    accent: '#E82E8A',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

middleware(router) // routes middleware

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js